export const CODIGO_RESTABELECIDO = 12;
export const CODIGO_DEFERIDO = 3;
export const CODIGO_INDEFERIDO = 6;
export const CODIGO_DESISTIDO = 15;
export const CODIGO_AGUARDANDO_PERICIA = 16;